module.exports = __webpack_public_path__ + "static/1369-1b90c54780064fb6f1cb2ea717f22b48.png";